function verticalSlider() {
 let verticalSlider = document.querySelectorAll('.vertical-slider');
 if (verticalSlider.length > 0) {
  for (let i = 0; i < verticalSlider.length; i++) {
   let verticalSliderBox = verticalSlider[i].querySelector('.vertical-slider-box');
   let verticalSliderContent = document.querySelector('.vertical-slider-content');
   let verticalSliderContainer = verticalSliderBox.querySelector('.vertical-slider-container');
   let verticalSliderList = verticalSliderContainer.querySelector('.vertical-slider-list');
   let verticalSliderItems = verticalSliderContainer.querySelectorAll('.vertical-slider-list LI');
   let verticalSliderItemHeight = verticalSliderContainer.querySelector('.vertical-slider-list LI').getBoundingClientRect().height + 8;
   let next = verticalSliderBox.querySelector('.next');
   let prev = verticalSliderBox.querySelector('.prev');
   let currentVerticalSlide = 0;
   let mediaMobile = window.matchMedia('(max-width: 630px)');

   function moveSlideVertical() {
    if (mediaMobile.matches) {
     if (currentVerticalSlide > verticalSliderItems.length - 2) {
      verticalSliderList.setAttribute('style', `${verticalSliderList.getAttribute('style')}`)
     } else {
      verticalSliderList.style.transform = `translateY(${currentVerticalSlide * verticalSliderItemHeight}px)`;
     }
    } else {
     if (currentVerticalSlide > verticalSliderItems.length - 4) {
      verticalSliderList.setAttribute('style', `${verticalSliderList.getAttribute('style')}`)
     } else {
      verticalSliderList.style.transform = `translateY(-${currentVerticalSlide * verticalSliderItemHeight}px)`;
     }
    }

    verticalSliderItems.forEach(item => {
     item.classList.remove('active')
    })

    verticalSliderItems[currentVerticalSlide].classList.add('active')
   }

   function cloneImages() {
    verticalSliderContent.querySelector('.content').remove();
    verticalSliderContent.appendChild(verticalSliderList.querySelector('li.active .content').cloneNode(true))
   }

   for (let s = 0; s < verticalSliderItems.length; s++) {
    verticalSliderItems[s].addEventListener('click', function (e) {
     e.preventDefault();

     verticalSliderItems.forEach(el => {
      el.classList.remove('active');
     })

     currentVerticalSlide = verticalSliderItems[s].getAttribute('data-verticale-slide');
     verticalSliderItems[s].classList.add('active');

     verticalSliderContent.querySelector('.content').remove();
     verticalSliderContent.appendChild(verticalSliderList.querySelector(`li[data-verticale-slide="${currentVerticalSlide}"]`).querySelector('.content').cloneNode(true))

     if (!mediaMobile.matches) {
      if (currentVerticalSlide === `${verticalSliderItems.length - 5}`) {
       currentVerticalSlide = 4;
       verticalSliderList.style.transform = `translateY(-${currentVerticalSlide * verticalSliderItemHeight}px)`;
      }

      if (currentVerticalSlide === `${verticalSliderItems.length - 4}`) {
       verticalSliderList.style.transform = `translateY(0px)`;
      }

      if (currentVerticalSlide <= 0) {
       prev.classList.add('in-active')
      }

      if (currentVerticalSlide >= 1) {
       prev.classList.remove('in-active')
      }

      if (currentVerticalSlide >= verticalSliderItems.length - 2) {
       next.classList.add('in-active')
      }

      if (currentVerticalSlide <= verticalSliderItems.length - 2) {
       next.classList.remove('in-active')
      }
     }
    })
   }

   next.addEventListener('click', (e) => {
    e.preventDefault();
    currentVerticalSlide++;

    prev.classList.remove('in-active')

    if (currentVerticalSlide > verticalSliderItems.length - 1) {
     currentVerticalSlide = 0;
    }

    if (currentVerticalSlide >= verticalSliderItems.length - 1) {
     next.classList.add('in-active')
    }
    setTimeout(() => {
     cloneImages()
    }, 100);

    moveSlideVertical()
   })

   prev.addEventListener('click', (e) => {
    e.preventDefault();

    currentVerticalSlide--;

    if (currentVerticalSlide < 0) {
     currentVerticalSlide = 0;
    }

    if (currentVerticalSlide <= 0) {
     prev.classList.add('in-active')
    }

    next.classList.remove('in-active')

    setTimeout(() => {
     cloneImages()
    }, 100);
    moveSlideVertical()
   })
  }
 }
}
verticalSlider()